module.exports = __webpack_public_path__ + "static/img/A17.376c36d5.jpg";